var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['form-button', { 'btn-primary': _vm.primary, 'btn-secondary': _vm.secondary ,'btn-danger': _vm.danger}],style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(" "+_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }